import { render } from "./FlatFeeCalculator.vue?vue&type=template&id=30c8258e"
import script from "./FlatFeeCalculator.vue?vue&type=script&lang=js"
export * from "./FlatFeeCalculator.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__